export class PostGetLocationQuickSearchRequest {
    language?: string;
    age? : number; 
    gender?: string;
    maxDisplayCount?: number;  
}